import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';


import Customers from "./Customers";
import AddCustomer from "./AddCustomer";
import EditCustomer from "./EditCustomer-f";
import Customer from "./Customer";
import Menu from "./Menu";
import List from "./List";
import Item from "./Item";

class CustomerAdministrator extends Component {
  render() {
    return (
      <Switch>
        <Route path="/customers" exact component={Customers} />
        <Route path="/customers/add" component={AddCustomer} />
        <Route path="/customers/:id" exact component={Customer} />
        <Route path="/customers/:id/edit" exact component={EditCustomer} />
        <Route path="/customers/:id/edit/:restId/menu" exact component={Menu} />
        {/*<Route*/}
          {/*path="/customers/:id/edit/:restId/menu/:menuId/list"*/}
          {/*exact*/}
          {/*component={List}*/}
        {/*/>*/}
        <Route
          path="/customers/:id/edit/:restId/menu/:menuId/item"
          component={Item}
        />
      </Switch>
    );
  }
}

export default CustomerAdministrator;



// WEBPACK FOOTER //
// ./src/components/Customer-administrator/index.js